import * as yup from "yup";

export type HelpAndSupportValidationType = yup.InferType<typeof HelpAndSupportValidation>;

export const HelpAndSupportValidation = yup.object().shape({
	commonHelp: yup.string().required("This is a required field"),
	additionalInfo: yup
		.string()
		.optional()
		.when("commonHelp", {
			is: "Other",
			then: (schema) => schema.trim().required("Please describe the issue when selecting Other"),
		}),
});
